import { countryCodes, languageCodes } from "~~/i18n";
import type { CountryCodeValue } from "~~/types/localization/localizationHelperTypes";

export const TRUSTPILOT_CAROUSEL_STARS_RATING: string = '4,5';

export const TRUSTPILOT_THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;

export const TRUSTPILOT_LOGOS = {
  BLACK: 'black',
  WHITE: 'white',
} as const;

export const TRUSTPILOT_MICRO_REVIEW_WIDGET_ID = '5419b6a8b0d04a076446a9ad';
export const TRUSTPILOT_MINI_WIDGET_ID = '53aa8807dec7e10d38f59f32';
export const TRUSTPILOT_MICRO_COMBO_WIDGET_ID = '5419b6ffb0d04a076446a9af';
export const TRUSTPILOT_MICRO_BUTTON_ID = '5419b757fa0340045cd0c938';
export const TRUSTPILOT_WIDGET_CAROUSEL_ID = '53aa8912dec7e10d38f59f36';
export const TRUSTPILOT_WIDGET_MINI_CAROUSEL_ID = '539ad0ffdec7e10e686debd7';
export const TRUSTPILOT_BUSINESS_UNIT_ID = '6180f0006bc505ee409c6af4';
export const TRUSTPILOT_BUSINESS_UNIT_NAME = 'expondo.com';

export const TRUSTPILOT_SUPPORTED_LANGUAGES = [
  languageCodes.de,
  languageCodes.en,
  languageCodes.es,
  languageCodes.fi,
  languageCodes.fr,
  languageCodes.it,
  languageCodes.nl,
  languageCodes.pt,
  languageCodes.pl,
  languageCodes.nb,
  languageCodes.da,
  languageCodes.sv,
];

export const HEUREKA_WIDGET_DATA: Partial<Record<CountryCodeValue, {
  setKey: string;
  pushParams: string[];
  scriptSrc: string;
  reviewsPage: string;
  mobileBadgeSrc: string;
}>> = {
  [countryCodes.CZ]: {
    setKey: 'C36BD6924F88BFB4EA7D9ADCA8E954E5',
    pushParams: ['showWidget', '11', '60979', 'expondo.cz', 'expondo-cz'],
    scriptSrc: 'https://cz.im9.cz/direct/i/gjs.php?n=wdgt&sak=C36BD6924F88BFB4EA7D9ADCA8E954E5',
    reviewsPage: 'https://obchody.heureka.cz/expondo-cz/recenze/',
    mobileBadgeSrc: 'https://im9.cz/cb/60979-4.svg',
  },
};
